import { useState, useEffect } from 'react';
import { fetchSlideBySlug, processACFData } from '../utils/slideDataHelpers';

const useAppContent = () => {
  const [appContent, setAppContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const content = await fetchSlideBySlug('app-content');

        if (content) {
          const processedContent = processACFData(content);
          setAppContent(processedContent);
        } else {
          throw new Error('No app content found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return {
    appContent,
    loading,
    error
  };
};

export default useAppContent;
